import React from 'react';

import { Box } from '@material-ui/core';

import { useOnboardingStyles } from '@vyce/core/src/components/AppOnboarding';

import '../formExportPrint.css';
import { FormSummaryPoweredByPrint } from './FormSummaryPoweredBy';
import { useFormExportPrintPage } from '../hooks/useFormExportPrintPage';

type Props = {
  /** e.g. Export PDF toolbar; omit when nothing to export */
  toolbar?: React.ReactNode;
  /** e.g. dialogs rendered after the print footer */
  footer?: React.ReactNode;
  /** Company logo URL for print/PDF only (e.g. company.logo?.url); hidden on screen */
  companyLogoUrl?: string | null;
  children: React.ReactNode;
};

/**
 * Shared shell for Form Summary / By question / By user: print CSS hook, outer flex, root column, fixed print footer.
 */
export const FormPrintLayout: React.FC<Props> = ({ toolbar, footer, companyLogoUrl, children }) => {
  const classes = useOnboardingStyles();
  useFormExportPrintPage();

  return (
    <Box
      className={`${classes.mainContainer} form-summary-print-outer`}
      style={{ display: 'flex', justifyContent: 'center', position: 'relative' }}
    >
      {toolbar}
      <Box
        className={`${classes.paper} form-summary-print-root form-summary-print-root--fill`}
        style={{ maxWidth: 700, width: '100%', gap: 24 }}
      >
        {companyLogoUrl ? (
          <Box className="form-summary-print-company-logo-wrap form-summary-print-only">
            <img className="form-summary-print-company-logo" src={companyLogoUrl} alt="" />
          </Box>
        ) : null}
        {children}
      </Box>
      <FormSummaryPoweredByPrint />
      {footer}
    </Box>
  );
};
